import config from '@/config';
import { loadDemoLead } from '@/components/DemoLead/demoLeadStorage';

export const isWebsiteDemoPractice = (practiceSlug?: string | null): boolean =>
  Boolean(config.demoPracticeSlug) && practiceSlug === config.demoPracticeSlug;

interface DemoLeadProfessional {
  firstname: string;
  lastname: string;
  medicalSpeciality: string;
}

export const getDemoLeadProfessional = (
  practiceSlug?: string | null,
): DemoLeadProfessional | null => {
  if (!isWebsiteDemoPractice(practiceSlug)) return null;
  const lead = loadDemoLead();
  const firstname = lead?.firstName?.trim() ?? '';
  const lastname = lead?.lastName?.trim() ?? '';
  const medicalSpeciality = lead?.speciality?.trim() ?? '';
  if (!firstname && !lastname) return null;
  return { firstname, lastname, medicalSpeciality };
};
